function UpIcon() {
    return (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.40135 15.4176C8.03322 16.6417 8.89911 18.9081 10.7349 18.9081L19.2655 18.9081C21.1013 18.9081 21.9672 16.6417 20.5991 15.4176L16.3338 11.6013C15.5745 10.922 14.4259 10.922 13.6666 11.6013L9.40135 15.4176Z"
                fill="#6E6864"/>
        </svg>
    );
}

export default UpIcon;
